import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

interface DisabledOverlayProps {
  zIndex?: number;
}

export const DisabledOverlay = styled(Stack)<DisabledOverlayProps>(
  ({ zIndex = 4 }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: "blur(6px)",
    zIndex,
    borderRadius: 6,
    justifyContent: "center",
    alignItems: "center",
  }),
);
